<template>
    <div
        :class="['date-picker-control', {'disabled': disabled}]" >
        <div
            class="date-input"
            @click.stop="toggleBox('toggle', $event)">
            <input
              v-model="formattedDateTest"
              type="text"
              :placeholder="placeholder"
              :readonly="!manualInput"
              @change="changeManualInputDate"
              @input="rocDateManualInputHandle($event)"
            />
            <!-- <input
                v-model="values"
                type="text"
                readonly
                class="d-none"
                /> -->
            <!-- <input
                v-model="formattedValues"
                :placeholder="placeholder"
                type="text"
                readonly /> -->
            <span
                v-if="!formattedDateTest"
                :class="['right-icon']"
                style="-webkit-mask: url('/static/img/common/time.svg') no-repeat center / contain" />
            <span
                v-else
                :class="['right-icon']"
                @click.stop="clearValue()"
                style="-webkit-mask: url('/static/img/common/Error.svg') no-repeat center / contain" />
        </div>
        <div
            v-if="openCalendar"
            v-click-outside="toggleBox"
            :class="['date-picker-box', {
                center: position === 'center',
                left: position === 'left',
                right: position === 'right'
            }]">
            <calendar-box
                :formatYear="formatYear"
                :local="local"
                :limitRange="limitDate"
                :selectDateStartTimeData="selectDateStartTimeData"
                @choose-end="updateDate($event)" />
        </div>
    </div>
</template>
<script>
import calendarBox from './DatePicker/CalendarBox';
import { convertRocDate, convertDateFormat } from "@/models/HELPERS/common.js";

export default {
    name: 'DatePicker',
    components: { calendarBox },
    model: {
        prop: 'values',
        event: 'change'
    },
    props: {
        position: {
            type: String,
            default: 'center'
        },
        min: {
            type: String,
            default: ''
        },
        max: {
            type: String,
            default: ''
        },
        values: {
            type: String,
            required: false,
            default: ''
        },
        formatYear: {
            type: String,
            required: false,
            default: 'twy'
        },
        local: {
            type: String,
            required: false,
            default: 'tw'
        },
        placeholder: {
            type: String,
            required: false,
            default: '請選擇日期'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        manualInput: {
          type: Boolean,
          required: false,
          default: false
        },
    },
    data() {
        return {
            openCalendar: false,
            selectDateStartTimeData: {
                year: '',
                month: '',
                date: ''
            },
            dateValue: '',
            formattedDateTest: ''
        }
    },
    computed: {
        limitDate() {
            let cut_min = this.min.split('-');
            let cut_max = this.max.split('-');
            let min_none = this.min === '';
            let max_none = this.max === '';
            return {
                min: {
                    open: !min_none,
                    full_date: this.min,
                    year: parseInt(cut_min[0]),
                    month: parseInt(cut_min[1]),
                    date: parseInt(cut_min[2])
                },
                max: {
                    open: !max_none,
                    full_date: this.max,
                    year: parseInt(cut_max[0]),
                    month: parseInt(cut_max[1]),
                    date: parseInt(cut_max[2])
                }
            }
        },
        formattedValues() {
            if (!this.values) return '';

            const year_calculate = this.formatYear === 'twy' ? 1911 : 0;
            const [year, month, day] = this.values.split("-");
            const gregorianYear = Number(year);
            const rocYear = gregorianYear - year_calculate;
            const formatted = `${rocYear}-${month}-${day}`;

            return formatted;
        },
        formattedDate: {
          get() {
            if (!this.values) return '';

            return this.formatYear === 'twy' ? convertRocDate(this.values) : convertDateFormat(this.values);
          },
          set(newValue) {
            this.values = newValue;
          },
        },
    },
    watch: {
      values: {
        handler(newValue, oldValue) {
          this.init();
        },
        immediate: true
      }
    },
    mounted() {
        // this.init();
    },
    methods: {
        init() {
            if (this.values) {
                const [year, month, day] = this.values.split("-");
                const formattedDay = parseInt(day, 10); // 解析day並轉換為整數

                this.selectDateStartTimeData = {
                    year: Number(year),
                    month: Number(month),
                    date: Number(formattedDay)
                }

                this.formattedDateTest = this.formatYear === 'twy' ? convertRocDate(this.values) : convertDateFormat(this.values);
            } else {
              this.clearValue();
            }
        },
        toggleBox(type = '', event) {
            if (type === 'toggle') {
                this.openCalendar = !this.openCalendar;
                return;
            }
            this.openCalendar = false;
        },
        updateDate(data) {
            this.selectDateStartTimeData = data;
            const date = convertDateFormat(`${data.year}-${data.month}-${data.date}`);

            this.openCalendar = false;
            this.$emit('change', date);
            this.$emit('dateChange');

            this.formattedDateTest = this.formatYear === 'twy' ? convertRocDate(date) : convertDateFormat(date);
        },
        clearValue() {
            this.$emit('change', '');
            this.$emit('dateChange');
            this.formattedDateTest = '';
        },
        changeManualInputDate() {
          if (!this.manualInput) return;

          const year_calculate = this.formatYear === 'twy' ? 1911 : 0;
          const [year, month, day] = this.formattedDateTest.split("-");
          const gregorianYear = Number(year);
          const rocYear = gregorianYear + year_calculate;
          const formattedDay = parseInt(day, 10); // 解析day並轉換為整數
          const formatted = `${rocYear}-${month}-${day}`;

          this.selectDateStartTimeData = {
            year: Number(rocYear),
            month: Number(month),
            date: Number(formattedDay)
          }
          this.$emit('change', formatted);
        },
        // 國曆年手動輸入處理
        rocDateManualInputHandle(event) {
          if (!this.manualInput) return;

          const cleanedInput = event.target.value.replace(/-/g, '');
          const yearPart = cleanedInput.slice(0, 3);
          const monthPart = cleanedInput.slice(3, 5);
          const dayPart = cleanedInput.slice(5, 7);

          let year = yearPart || '';
          let month = monthPart || '';
          let day = dayPart || '';

          if (month.length === 2) {
            const numericMonth = parseInt(month, 10);
            if (numericMonth > 12) {
              month = '';
            }
          }

          if (month && day) {
            const numericYear = Number(year) + 1911;
            const numericMonth = Number(month);
            const maxDays = new Date(numericYear, numericMonth, 0).getDate();
            const numericDay = Number(day);

            if (numericDay > maxDays) {
              day = '';
            }
          }

          if (year.length === 3 && !month && !day) {
            // 若只剩3個數字的年份，並且月和日都沒有，就保持原樣
            this.formattedDateTest = year;
          } else if (year.length === 3 && month && month.length === 2 && !day) {
            // 若只剩3個數字的年份，有月份但沒有日期，保持年份和月份
            this.formattedDateTest = `${year}-${month}`;
          } else if (year.length === 3  && month && month.length === 2 && day) {
            // 若只剩3個數字的年份，有月份和日期，保持完整日期
            this.formattedDateTest = `${year}-${month}-${day}`;
          }
        },
    }
}
</script>
<style lang="sass" scoped>
.date-picker-control
    // min-width: 240px
    min-height: 34px
    padding: 0 20px 0px 12px
    box-sizing: border-box
    display: flex
    justify-content: left
    align-items: center
    border: 1px solid #5083DA
    border-radius: 18px
    font-size: 11px
    position: relative
    &.focused
        border: 1px solid #5083DA
        .image
            background-color: #5083DA
    &:focus
        outline: none
    &.disabled
        pointer-events: none;
        background-color: #e9ecef;
        opacity: 1;
    .image
        content: ''
        position: absolute
        right: 15px
        background-color: rgba(157, 172, 198, 0.5)
        width: 8px
        height: 8px

.date-picker-box
    position: absolute
    top: 125%
    background: #FFFFFF
    border-radius: 10px
    z-index: 500
    &.right
        right: 0
    &.left
        left: 0
    &.center
        left: 50%
        transform: translateX(-50%)

.date-input
    width: 100%
    height: 100%
    text-align: center
    cursor: pointer
    position: relative
    input
        width: 100%
        height: 100%
        background: transparent
.right-icon
    position: absolute
    top: 50%
    right: 0
    width: 12px
    height: 12px
    background: #5083DA
    transform: translateY(-50%)
</style>



// WEBPACK FOOTER //
// src/components/common/DatePicker.vue